import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Modal, Button } from 'react-bootstrap';
import { toast } from 'react-toastify';
import axios from 'axios';

import styles from './index.module.scss';

// excluir registro
export default function ModalExcluir({
    id,
    aoFechar,
    aoDeletar
}){
    // estados
    const [salvando, alterarSalvando] = useState(false);

    // exclui registro
    async function excluir(){
        alterarSalvando(true);

        try {

            // faz a requisição
            await axios.delete(`/emailsListaNegra/${id}`);

            toast(({ closeToast }) => <>
                <div className="toast-header">
                    <strong className="mr-auto">Registro excluído com sucesso!</strong>
                    <button 
                        onClick={closeToast} 
                        className="ml-2 mb-1 close btn-outline-light outline-0"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            </>, { autoClose: 3000 });

            aoDeletar();
        } catch({ response }) {
            console.error(response);
            
            // caso retornou erro
            if(response?.data && Object.keys(response.data)) {

                // resgata primeira chave do erro
                const erroChave = Object.keys(response.data)[0];
                
                // mensagem de erro
                toast(<>
                    <div
                        style={{ background: '#ff6271' }}
                    >
                        <div className="toast-header">
                            <strong className="mr-auto">Erro ao excluir!</strong>
                            <button
                                className="ml-2 mb-1 close btn-outline-light outline-0"
                            >
                            </button>
                        </div>
                        <div className="toast-body text-light">
                            <p>{response.data[erroChave]}</p>                            
                        </div>
                    </div>
                </>);

            }
        } finally {
            alterarSalvando(false);
        }
        
    }

    return (
        <Modal 
            show
            onExited={aoFechar}
            onHide={aoFechar}
            centered
            size={'md'}
            contentClassName={styles['conteudo-customizado']}
        >
            <Modal.Header className='border-0'>
                <Modal.Title className='fw-bold'>
                    Excluir
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className='mb-3'>
                <p 
                    className='text-justify m-0' 
                    style={{ fontWeight: 500 }}
                >
                    Você deseja remover o email da lista?<br/> Após a remoção, os próximos emails serão enviados para este endereço caso estiver em algum cadastro.
                </p>
            </Modal.Body>
            <Modal.Footer className='border-0 w-100 justify-content-between'>
                <Button
                    variant='danger'
                    onClick={aoFechar}
                    disabled={salvando}
                    size='md'
                >
                    <span>Desistir</span>
                </Button>
                <Button
                    onClick={excluir}
                    variant='success'
                    disabled={salvando}
                    size='md'
                >
                    {salvando ? 
                        <>
                            <FontAwesomeIcon className="icone" pulse icon={["fas", 'spinner']} />
                            <span>Excluindo</span>
                        </> : 
                        <span>Excluir</span>
                    }
                </Button>
            </Modal.Footer>
        </Modal>
    )

}